import "../css/app.css";
import LazyLoad from "vanilla-lazyload";

window.addEventListener("load", function () {
    init();
});

function init() {
    let myLazyLoad = new LazyLoad();
    myLazyLoad.update();

    console.log("init scripts...");
    
    import('./partials/cookie-consent.js');
    import('./partials/menus.js');
    import('./partials/audio-player.js');

    let gsapElement = document.querySelector(".gsap");
    if( gsapElement != null ) {
        import('./partials/animation.js');
    }

    let carousel = document.querySelector(".splide");
    if( carousel != null ) {
        import('./partials/carousel.js');
    }

    let tabs = document.querySelector(".tabs");
    if( tabs != null ) {
        import('./partials/tabs.js');
    }

    let modals = document.querySelector("[data-micromodal-trigger]");
    if( modals != null ) {
        import('./partials/modal.js');
    }

    let filters = document.querySelector("[data-js-filter]");
    if( filters != null ) {
        import('./partials/filters.js');
        import('./partials/infinate-scroll.js');
    }

    let youtubeVideo = document.querySelector(".video-youtube");
    let vimeoVideo = document.querySelector(".video-vimeo");
    let jsVideo = document.querySelector("[data-js-play]");
    if( youtubeVideo != null || vimeoVideo != null || jsVideo != null ) {
        import('./partials/video.js');
    }
}

// import { createApp, defineAsyncComponent, ref } from 'vue';

// import Items from "./components/CoLabItems.vue";

// const app = createApp({
//   delimiters: ['${', '}'],

//   components: {
//       Items
//   },
//   created() {
    
//   },
//   destroyed() {
    
//   },
//   setup() {

//   },
// });


// app.mount("#app");